import {
	STATUS_BADGE_TONE_PALETTES,
	type StatusBadgePalette,
} from "@/shared/components/status-badge";
import type { InspectionItem } from "../types/inspections";

export const canGetPdf = (item: InspectionItem) =>
	item.checklistFileStatus === 3;

export const inspectionStatusBadgePalettes: Record<string, StatusBadgePalette> =
	{
		Pendente: STATUS_BADGE_TONE_PALETTES.warning,
		Processando: STATUS_BADGE_TONE_PALETTES.warning,
		Concluido: STATUS_BADGE_TONE_PALETTES.success,
		Falha: STATUS_BADGE_TONE_PALETTES.error,
		QueueFailed: STATUS_BADGE_TONE_PALETTES.error,
		TimedOut: STATUS_BADGE_TONE_PALETTES.orange,
	};

export const getInspectionStatusBadgePalette = (
	fileStatus: string
): StatusBadgePalette =>
	inspectionStatusBadgePalettes[fileStatus] ?? STATUS_BADGE_TONE_PALETTES.gray;

export const statusMap: Record<string, string> = {
	PENDING: "Pendente",
	PROCESSING: "Processando",
	COMPLETED: "Concluido",
	FAILED: "Falha",
	QUEUEFAILED: "QueueFailed",
	TIMEDOUT: "TimedOut",
};

export const mapStatus = (fileStatus?: string) => {
	if (!fileStatus) {
		return "";
	}

	const normalized = fileStatus.trim().toUpperCase();
	return statusMap[normalized] || fileStatus;
};
